import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import _, { isEmpty, groupBy, find, get, set, filter } from 'lodash';
import { cloneData, groupByNestedArray, checkCurrency, shortenStringWithTooltip, roundOff, roundingOff } from '../../../../../Components/helper';
import AverageCostingExpandView from './ExpandView/AverageCostingExpandView';
import GranTotalDetailCostingExapandView from './ExpandView/GranTotalDetailCostingExapandView';
import useShowHideSectionHooks from '../Hooks/useShowHideSectionHooks';

export function GrandTotal({ productInfoObj }) {
  const { productCostingstate, setGrandTotalState } = productInfoObj;
  const { t } = useTranslation('common');

  const {
    averageCosting: { averageCostingInfo, averageCostingActive, overAllSumOfTotalPrice, totLength, totSize },
    detailedCosting: { bomTypeArr, detailedCostingActive },
    productInfo: { currency },
    quantities: { quantitiesInfo },
    testing: { testingInfo },
    additional: { additionalInfo },
    quantities,
    isBreakdown,
  } = productCostingstate;
  const { hideLengthCol } = useShowHideSectionHooks(productInfoObj);

  const [state, setState] = useState({
    grandTotol: [],
    totalBomTypeTotalPrice: '0',
  });

  useEffect(() => {
    if (averageCostingActive) {
      if (Array.isArray(averageCostingInfo) && averageCostingInfo?.length > 0) {
        const data = cloneData(averageCostingInfo);
        const updatedAverageCosting = [];
        if (Array.isArray(data) && data.length > 0) {
          for (const element of data) {
            element.expandData = filter(element?.expandData, function (o) {
              return parseFloat(o.pricePerUnit) > 0 && parseFloat(o.quantityPerSizCol) > 0;
            });
            element.expandData = element.expandData.map((exps) => {
              if (!exps?.colourway) {
                exps.colourway = element?.colourway;
              }
              return exps;
            });
            updatedAverageCosting.push(element);
          }
        }
        setState((prevState) => ({
          ...prevState,
          grandTotol: updatedAverageCosting,
        }));
        setGrandTotalState((prevState) => ({
          ...prevState,
          grandTotal: updatedAverageCosting,
        }));
      }
    }
  }, [averageCostingActive, averageCostingInfo]);

  const populateNestedBomData = async (bomTypeData) => {
    const manipulateBomArray = [];
    if (Array.isArray(bomTypeData) && bomTypeData.length > 0) {
      for (const element of bomTypeData) {
        for (const data of element.detailedCostingInfo) {
          if (data.colourway) {
            const obj = { ...data };
            manipulateBomArray.push(obj);
          }
        }
      }
    }
    return manipulateBomArray;
  };

  useEffect(() => {
    const callFn = async () => {
      const cloneQuantities = cloneData(quantitiesInfo);
      const testing = testingInfo;
      const bomTypeData = bomTypeArr;
      const additional = additionalInfo;
      // manipuate detail costing bom  array  by colourway
      const manipulateBomArray = await populateNestedBomData(bomTypeData);

      let totalBomTypeTotalPrice = '0';
      if (Array.isArray(cloneQuantities) && cloneQuantities.length > 0 && Array.isArray(manipulateBomArray) && manipulateBomArray.length > 0) {
        // grouping detailed costing by colourway
        const groupedBomData = groupBy(manipulateBomArray, (item) => item?.colourway?._id);
        // loop quantities data for updating keys and sum of total price and price per unit
        const quantitiesUpdatedArray = [];
        for (const quaData of cloneQuantities) {
          const bomColourwayMatchedDAta = groupedBomData[quaData?.colourway?._id];

          // LOOP QUANTITIES EXPAND DATA FOR UPDATING EACH COLOURWAY/SIZE/LENGTH COMBINATION TOTAL PRICE AND PRICE PER UNIT
          let sumOfTotalPrice = '0';
          let totWeightagePricePerUnit = '0';
          let totalQuantity = '0';
          quaData.isGTExpanded = false;
          const quantitiesExpandData = filter(quaData.expandData, function (o) {
            return parseFloat(o.quantityPerSizCol) > 0;
          });
          const updatedQuantitiesExpandData = [];
          for (const quaExpData of quantitiesExpandData) {
            let totalPrice = '0';
            const addAdditionalCost = '0';
            const quaSizeId = quaExpData?.size;
            const quaLengthId = quaExpData?.length?._id;
            let totalPricePerUnit = '0';
            const path = 'colourway._id';
            quaExpData.colourway = quaData?.colourway;
            const groupTestingData = _(testing)
              .filter((object) => _.has(object, path) && object?.isExcluded === false)
              .groupBy(path)
              .value();

            const tesetingColourBasedArray = groupTestingData[quaData?.colourway?._id];

            if (tesetingColourBasedArray) {
              tesetingColourBasedArray.forEach((test) => {
                totalPricePerUnit = +totalPricePerUnit + +test?.pricePerUnit;
              });
            }
            const groupAdditionalData = groupByNestedArray(additional, 'colourway');
            if (!isEmpty(groupAdditionalData) && groupAdditionalData[quaData?.colourway?._id]) {
              groupAdditionalData[quaData?.colourway?._id].forEach(function (data) {
                const priceToAdd = data.totalPrice / data?.colourway?.length;
                totalPricePerUnit = +totalPricePerUnit + +priceToAdd;
              });
            }
            // loop bom colourway data for getting the sum of size/length combiantion for quantities total price column
            if (Array.isArray(bomColourwayMatchedDAta) && bomColourwayMatchedDAta?.length > 0) {
              for (const bomColourwayData of bomColourwayMatchedDAta) {
                const findMatchedUnit = find(bomColourwayData?.expandData, function (o) {
                  return ((o?.size === quaSizeId && o?.length?._id === quaLengthId) || o?.size?.name === quaSizeId) && !o?.isExcluded;
                });
                if (findMatchedUnit) {
                  totalPricePerUnit = +totalPricePerUnit + +findMatchedUnit?.totalPrice;
                  if (totalPricePerUnit) {
                    quaExpData.pricePerUnit = totalPricePerUnit;
                  }
                  totalPrice = totalPricePerUnit * quaExpData?.quantityPerSizCol;
                }
              }
            }
            quaExpData.totalPrice = totalPrice;
            sumOfTotalPrice = +sumOfTotalPrice + +totalPrice;
            totWeightagePricePerUnit = Number(totalPrice) + Number(totWeightagePricePerUnit);
            totalQuantity = Number(totalQuantity) + Number(quaExpData?.quantityPerSizCol);
            if (addAdditionalCost) {
              quaData.sumOfTotalPrice = sumOfTotalPrice;
            }
            updatedQuantitiesExpandData.push(quaExpData);
          }
          quaData.expandData = updatedQuantitiesExpandData;
          totalBomTypeTotalPrice = +totalBomTypeTotalPrice + +sumOfTotalPrice;
          quaData.totWeightagePricePerUnit = totWeightagePricePerUnit / totalQuantity;

          quantitiesUpdatedArray.push(quaData);
        }
        setState((prevState) => ({
          ...prevState,
          grandTotol: quantitiesUpdatedArray,
          totalBomTypeTotalPrice,
        }));
        setGrandTotalState((prevState) => ({
          ...prevState,
          grandTotal: quantitiesUpdatedArray,
        }));
      }
    };
    if (detailedCostingActive && bomTypeArr.length > 0) callFn();
  }, [detailedCostingActive, bomTypeArr, quantitiesInfo, testingInfo, additionalInfo]);

  useEffect(() => {
    if (!averageCostingActive && !detailedCostingActive) {
      setState((prevState) => ({
        ...prevState,
        grandTotol: [],
        totalBomTypeTotalPrice: '0',
      }));
    }
  }, [averageCostingActive, detailedCostingActive]);

  const expandGrandTotalChild = (index) => {
    const copyState = state;
    const path = `grandTotol[${index}].isGTExpanded`;
    const pathEx = `grandTotol[${index}].isExpanded`;

    const expanded = get(copyState, path, false);
    const expandedEX = get(copyState, path, false);
    set(copyState, path, !expanded);
    set(copyState, pathEx, !expandedEX);

    setState((prevState) => ({
      ...prevState,
      ...copyState,
    }));
  };
  const renderComponent = Array.isArray(state?.grandTotol) && state?.grandTotol?.length > 0;

  const truthyValue = (data, index) => {
    return !data?.isGTExpanded && data?.expandData.length !== 1 && !isBreakdown ? (
      <tr key={data?._id}>
        <td>
          {data?.expandData &&
            data?.expandData.length > 0 &&
            (data.isGTExpanded ? (
              <button
                className="btn-up-down"
                type="button"
                aria-label={t('COMMON_LABEL.OPEN')}
                onClick={() => {
                  expandGrandTotalChild(index);
                }}
              >
                <span className="icon-new-down-arrow-icon icon-inverse" />
              </button>
            ) : (
              <button
                className="btn-up-down"
                type="button"
                aria-label={t('COMMON_LABEL.CLOSE')}
                onClick={() => {
                  expandGrandTotalChild(index);
                }}
              >
                <span className="icon-new-down-arrow-icon" />
              </button>
            ))}
        </td>
        <td>
          <span className="f-16 text-medium">{data?.colourway?.name}</span>
        </td>
        <td>
          <span className="f-16 text-medium">{data.isGTExpanded ? '--' : Array.isArray(totSize) && shortenStringWithTooltip(totSize.join(', '), 25)}</span>
        </td>
        {hideLengthCol && (
          <td>
            <span className="f-16 text-medium">
              {data.isGTExpanded ? '--' : Array.isArray(totLength) && shortenStringWithTooltip(totLength.join(', '), 25)}
            </span>
          </td>
        )}
        <td className="text-left">
          <span className="f-16 text-medium">{roundOff(data?.sumOfQuantityPerSizCol, 4, true)}</span>
        </td>
        <td className="text-left">
          <span className="f-16 text-medium">{roundOff(data?.totWeightagePricePerUnit, 4, true)}</span>
        </td>
        <td className="text-left">
          <span className="f-16 text-medium">
            {checkCurrency(currency, data?.sumTotalPrice)} {roundingOff(data?.sumTotalPrice, 2, true)}
          </span>
        </td>
      </tr>
    ) : (
      (data?.isExpanded || data?.expandData?.length === 1 || isBreakdown) && (
        <AverageCostingExpandView
          expandData={isBreakdown ? [data?.expandData[0]] : data?.expandData}
          index={index}
          isReadonly
          isExpanded={data?.isGTExpanded}
          expandAverageCostingChild={expandGrandTotalChild}
          colourway={data?.colourway}
          sizeRange={data?.sizeRange}
          lengthRange={data?.lengthRange}
          productInfoObj={productInfoObj}
        />
      )
    );
  };

  const falsyValue = (data, index) => {
    return !data?.isGTExpanded && !isBreakdown ? (
      <tr key={data?._id}>
        <td className="text-left">
          {data?.expandData &&
            data?.expandData.length > 0 &&
            (data.isGTExpanded ? (
              <button
                className="btn-up-down"
                type="button"
                aria-label={t('COMMON_LABEL.OPEN')}
                onClick={() => {
                  expandGrandTotalChild(index);
                }}
              >
                <span className="icon-new-down-arrow-icon icon-inverse" />
              </button>
            ) : (
              <button
                className="btn-up-down"
                type="button"
                aria-label={t('COMMON_LABEL.CLOSE')}
                onClick={() => {
                  expandGrandTotalChild(index);
                }}
              >
                <span className="icon-new-down-arrow-icon " />
              </button>
            ))}
        </td>
        <td>
          <span className="f-16 text-medium">{data?.colourway?.name}</span>
        </td>
        <td>
          <span className="f-16 text-medium">
            {data.isGTExpanded ? '--' : Array.isArray(quantities?.totSize) && shortenStringWithTooltip(quantities?.totSize.join(', '), 25)}
          </span>
        </td>
        {hideLengthCol && (
          <td>
            <span className="f-16 text-medium">
              {data.isGTExpanded ? '--' : Array.isArray(quantities?.totLength) && shortenStringWithTooltip(quantities?.totLength.join(', '), 25)}
            </span>
          </td>
        )}
        <td className="text-left">{roundOff(data?.sumOfQuantityPerSizCol, 4, true)}</td>
        <td className="text-left">
          {' '}
          <span className="f-16 text-medium">{roundOff(data?.totWeightagePricePerUnit, 4, true)}</span>
        </td>
        <td className="text-left">
          <span className="f-16 text-medium">
            {checkCurrency(currency, data?.sumOfTotalPrice)} {roundingOff(data?.sumOfTotalPrice, 2, true)}
          </span>
        </td>
      </tr>
    ) : (
      (data.isGTExpanded || isBreakdown) && (
        <GranTotalDetailCostingExapandView
          expandData={isBreakdown ? [data?.expandData[0]] : data?.expandData}
          index={index}
          isReadonly
          isExpanded={data?.isGTExpanded}
          expandGrandTotalChild={expandGrandTotalChild}
          colourway={data?.colourway}
          sizeRange={data?.sizeRange}
          lengthRange={data?.lengthRange}
          productInfoObj={productInfoObj}
        />
      )
    );
  };

  return (
    <div className="table-responsive average-colourway-table table-max-h-50">
      <table className="table common-class-bottom common-custom-table product-costing-tbl ">
        <thead>
          <tr>
            <th className="w-50px" />
            <th className="w-150px">{t('COSTING_TO_DO_LIST.COLORWAY')}</th>
            <th className="w-150px">{t('ORDER_PREVIEW_DETAILS.SIGE')}</th>
            {hideLengthCol && <th className="w-150px">{t('PROGRESS_INDICATOR.LENGTH')}</th>}
            <th className="w-150px">{t('COSTING_TO_DO_LIST.QUANTITY')}</th>
            <th className="w-150px">{isBreakdown ? 'Price Per Unit' : 'Price Per Unit (Average)'}</th>
            <th className="w-150px">{t('FILTER.TOTAL_PRICE')}</th>
          </tr>
        </thead>
        {renderComponent ? (
          <tbody>
            {state?.grandTotol?.map((data, index) => {
              return averageCostingActive ? truthyValue(data, index) : falsyValue(data, index);
            })}
            <tr>
              <td colSpan={hideLengthCol ? '6' : '5'} />
              <td className="text-left">
                <span className="f-16 text-bold">
                  {' '}
                  {checkCurrency(currency, state?.totalBomTypeTotalPrice)}{' '}
                  {detailedCostingActive ? roundingOff(state?.totalBomTypeTotalPrice, 2, true) : roundingOff(overAllSumOfTotalPrice, 2, true)}
                </span>
              </td>
            </tr>
          </tbody>
        ) : null}
      </table>
    </div>
  );
}

export default GrandTotal;
